var map = {
	"./fanfare.mp3": 8020,
	"./kyrandia-playing-with-merith.mp3": 2338,
	"./kyrandia-the-forest.mp3": 5305,
	"./kyrandia-the-timbermist-woods.mp3": 8279,
	"game-files/audio/music/fanfare.mp3": 8020,
	"game-files/audio/music/kyrandia-playing-with-merith.mp3": 2338,
	"game-files/audio/music/kyrandia-the-forest.mp3": 5305,
	"game-files/audio/music/kyrandia-the-timbermist-woods.mp3": 8279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7680;